/* eslint-disable no-undef */
// CONFIG comes from webpack injection of global variable (see webpack.config.base.js)
export const getApiUrl = service => {
  return `${CONFIG.api.apiRoot}${CONFIG.api.services[service]}`;
};

export const getGatewayUrl = service => {
  return `${CONFIG.api.apiRoot}${CONFIG.api.services.gateway}${CONFIG.api.services[service]}`;
};
